import React from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { rationalNumbers } from 'Core/masks'

import { TextInputNew, Wrapper } from 'SRC/ui/FormElementsNew'

export const RegularPrice = () => {
	const formik = useFormikContext()

	React.useEffect(() => {
		if (Number(formik.initialValues.price) === -1) formik.setFieldValue('price', '', false)

		return () => { formik.setFieldValue('price', -1, false) }
	}, [])

	const error = formik.touched.price && formik.errors.price

	return (
		<Wrapper isError={error}>
			<TextInputNew
				id='price'
				name='price'
				title='Cijena'
				isRequired
				value={formik.values.price}
				mask={rationalNumbers}
				allowedCharacters={['rational']}
				measure='€'
				onChange={async textValue => {
					const discountedPriceValue = Number(formik.values.discountedPrice)

					formik.setFieldValue('price', Number(textValue) < discountedPriceValue ? -1 : textValue)

					if (!formik.touched.price) formik.setFieldTouched('price', true)

					formik.setErrors({
						...formik.errors,
						price: formik.touched.price && [0, -1].includes(Number(textValue)) ? 'Popunite cijenu' : undefined
					})
				}}
			/>

			<ErrorMessage
				name='price'
				render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
			/>
		</Wrapper>
	)
}
